(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/wager/views/no-money-message.js') >= 0) return;  svs.modules.push('/components/tur/wager/views/no-money-message.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tur=_svs.tur||{};
_svs.tur.wager=_svs.tur.wager||{};
_svs.tur.wager.templates=_svs.tur.wager.templates||{};
svs.tur.wager.templates.no_money_message = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <p>Bolaget <span class=\"f-bold\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"syndicateName") || (depth0 != null ? lookupProperty(depth0,"syndicateName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"syndicateName","hash":{},"data":data,"loc":{"start":{"line":2,"column":34},"end":{"line":2,"column":51}}}) : helper)))
    + "</span> har inte tillräckligt med pengar för att betala spelet.</p>\n";
},"1":function(container,depth0,helpers,partials,data) {
    return "  <p>Du har inte tillräckligt med pengar på ditt spelkonto för att betala ditt spel.</p>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  Saldo: "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"balance") || (depth0 != null ? lookupProperty(depth0,"balance") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"balance","hash":{},"data":data,"loc":{"start":{"line":8,"column":9},"end":{"line":8,"column":20}}}) : helper)))
    + " kr\n";
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <br />Pris: "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cost") || (depth0 != null ? lookupProperty(depth0,"cost") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cost","hash":{},"data":data,"loc":{"start":{"line":12,"column":14},"end":{"line":12,"column":22}}}) : helper)))
    + " kr\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isSyndicate") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"hasBalance") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":9,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"hasCost") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":0},"end":{"line":13,"column":7}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['components-tur-wager-no_money_message'] = svs.tur.wager.templates.no_money_message;
})(svs, Handlebars);


 })(window);